
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.109 14.173"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.108.5a1.8 1.8 0 000 3.573h13.893V.768a.275.275 0 00-.281-.267z"}}),_c('path',{attrs:{"d":"M17.581 4.339a.274.274 0 00-.281-.266H2.108A1.737 1.737 0 01.515 2.385a.038.038 0 00-.015.03v9.344a1.781 1.781 0 001.608 1.914h13.893a1.781 1.781 0 001.609-1.914z"}}),_c('path',{attrs:{"d":"M15.013 9.668h-.593a.968.968 0 01-.988-.94h0a.967.967 0 01.988-.94h.593a.967.967 0 01.988.94h0a.968.968 0 01-.988.94z"}})])])
          )
        }
      }
    